module.exports = "/images/vendor/flag-icon-css/flags/1x1/py.svg?a70b32d0609b162db211927e72a218d4";